import {ChevronRightIcon, MinusIcon, PlusIcon} from '@heroicons/react/solid';
import {useState} from 'react';
import {Link} from 'react-router-dom';

import {Button, Table, TBody, Td, Th, Thead, Tr} from '@/components';
import {appPaths} from '@/config/appPaths';
import type {AdminAfriexRewardCard} from '@/types';
import {formatDate} from '@/utils/date';

const RewardCardTable = ({items}: {items: AdminAfriexRewardCard[]}) => {
  return (
    <Table className="overflow-hidden">
      <Thead>
        <Tr enableHover={false}>
          <Th>&nbsp;</Th>
          <Th>Code</Th>
          <Th>Is Used</Th>
          <Th>Used By</Th>
          <Th>Date</Th>
          <Th>&nbsp;</Th>
        </Tr>
      </Thead>

      <TBody>
        {items.map((item, index) => (
          <TRow item={item} key={index} index={index} />
        ))}
      </TBody>
    </Table>
  );
};

const TRow = ({item, index}: {item: AdminAfriexRewardCard; index: number}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const zebraRow = index % 2 === 0 ? '' : 'bg-gray-50 dark:bg-dark-zebraRow';

  return (
    <Tr className={zebraRow}>
      <Td isNumeric className="px-3">
        <Button onClick={() => setIsExpanded(!isExpanded)} variant="unStyled">
          <div
            className={`border-2 border-gray-700 dark:border-dark-borderLight dark:text-gray-100 text-gray-700 w-5 h-5 flex justify-center rounded hover:bg-cyan-50 ${
              isExpanded && 'bg-cyan-50'
            }`}
          >
            {isExpanded ? (
              <MinusIcon className="w-4 h-4" />
            ) : (
              <PlusIcon className="w-4 h-4" />
            )}
          </div>
        </Button>
      </Td>
      <Td className={`font-medium`}>*****</Td>
      <Td className={`px-3 py-4`}>
        <div className="break-words">
          {item.isDeactivated?.toString()?.toUpperCase()}
        </div>
      </Td>
      <Td>
        {item.isDeactivated ? (
          <Link to={`/${appPaths.users}/${item?.redeemedBy?.userId}`}>
            {item?.redeemedBy?.name}
          </Link>
        ) : (
          '-'
        )}
      </Td>
      <Td>
        {item?.redeemedBy?.redeemedAt || formatDate(item?.updatedAt || '')}
      </Td>
      <Td>
        <div
          className="w-5 h-5 flex justify-center items-center text-gray-700 dark:text-gray-300 hover:border rounded-lg hover:border-gray-300 hover:bg-cyan-50 hover:text-cyan-500 cursor-pointer"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <ChevronRightIcon className="w-5 h-5" />
        </div>
      </Td>
    </Tr>
  );
};

export default RewardCardTable;
